import { useEffect, useState } from 'react'
import PermissionsService from 'Services/PermissionsService'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setSelection, setSelectionType } from '../SpreadSheetDataProvider/actions'
import { useTableData } from '../TableDataProvider'
import CellContents from './CellContents'
import BaseCell from './BaseCell'
import { selectionTypes } from '../helpers'

BodyCell = ({
  columnIndex,
  rowIndex,
  ...rest
}) ->

  [{
    columns,
    edits,
    isDragging,
    nodeOrder,
    relationsMap,
    selectionType,
    selection
  }, dispatch] = useSpreadSheetData()

  key = nodeOrder[rowIndex]
  [{ [key]: node }] = useTableData()

  [isEditing, setIsEditing] = useState(undefined)

  whichSingleCellIsSelected = ->
    if selectionType is selectionTypes.CELL
      selection
    else if selectionType is selectionTypes.MULTI_CELL and _.isEqual(selection[0], selection[1])
      selection[0]
    else
      undefined

  useEffect( ->
    if cell = whichSingleCellIsSelected()
      try
        [c, r] = cell
        if columns[c].editFn or columns[c].createWithId or columns[c].relationConf
          setIsEditing("#{r}-#{c}")
      catch # needed because sometimes the structure of `selection` won't look like `[x, y]`
        setIsEditing(false)
    else
      setIsEditing(undefined)
    undefined
  , [selection, selectionType])

  r = rowIndex
  c = columnIndex

  return <span /> unless columns[c]

  contents = (
    if edits[rowIndex]?[c]?
      edits[rowIndex][c]
    else if node
      columns[c].renderFn(node)
    else
      undefined
  )

  selectSingleCell = ->
    dispatch(setSelectionType(selectionTypes.CELL))
    dispatch(setSelection([c, r]))

  includeCellInSelection = ->
    if _.isArray(selection[0])
      parsedSelection = selection[0]
    else
      parsedSelection = selection
    dispatch(setSelectionType(selectionTypes.MULTI_CELL))
    dispatch(setSelection([parsedSelection, [c, r]]))

  <BaseCell
    rowIndex={r}
    colIndex={c}
    dataTestid={"spreadsheet-cell-#{r}-#{c}"}
    onMouseDown={(e) ->
      return if e.button is 2
      if e.shiftKey
        includeCellInSelection()
      else if e.ctrlKey
        # This is a noop
        # Need this to ensure link click propagate
      else
        selectSingleCell()
    }
    onMouseMove={if isDragging then includeCellInSelection}
    { ...rest }
  >
    <CellContents
      isEditing={isEditing is "#{r}-#{c}"}
      isEmpty={!key?}
      isReadOnly={!PermissionsService.isEditable(columns[c].key, !!columns[c].relationConf)}
      isRelationCol={!!columns[c].relationConf}
      contents={contents}
      dataType={node?.getDataType(columns[c].key)}
      r={rowIndex}
      c={c}
      relationsMap={relationsMap}
      column={columns[c]}
    />
  </BaseCell>

export default BodyCell
